import styled from 'styled-components'

import { StatusType } from 'schema/contract'

const Container = styled.div`
  display: flex;
  position: relative;
  background: transparent;
  width: 100%;
  margin: 10px 0 12px 0;
  border-bottom: 1px solid #cccccc;

  @media only screen and (max-width: ${(p) => p.theme.vp}px) {
    margin: 10px auto 12px auto;
  }
`

const Status = styled.button<{ active: boolean }>`
  padding: 12px 16px 4px 16px;
  background: none;
  border: none;
  color: ${(p) => (p.active ? '#000000' : '#666666')};
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  text-align: center;
  width: auto;
  min-width: fit-content;

  &:hover {
    color: ${(p) => (p.active ? '#000000' : '#333333')};
  }

  ${(p) =>
    p.active &&
    `
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 3px;
      background-color: #F39800;
      border-radius: 2px 2px 0 0;
    }
  `}

  @media only screen and (max-width: ${(p) => p.theme.vp}px) {
    flex: 1;
    width: 100%;
  }
`

export const ContractedStatusTub = ({
  status,
  setStatus,
  inProgressCount,
  doneCount,
}: {
  status: StatusType
  setStatus: (status: StatusType) => void
  inProgressCount?: number
  doneCount?: number
}) => {
  return (
    <Container>
      <Status
        onClick={() => setStatus('inProgress')}
        active={status === 'inProgress'}
      >
        掲載中 {inProgressCount !== undefined && `(${inProgressCount})`}
      </Status>
      <Status onClick={() => setStatus('done')} active={status === 'done'}>
        売却済/掲載終了 {doneCount !== undefined && `(${doneCount})`}
      </Status>
    </Container>
  )
}

export const FetaureStatusTub = ({
  status,
  setStatus,
  inProgressCount,
  doneCount,
}: {
  status: StatusType
  setStatus: (status: StatusType) => void
  inProgressCount?: number
  doneCount?: number
}) => {
  return (
    <Container>
      <Status
        onClick={() => setStatus('inProgress')}
        active={status === 'inProgress'}
      >
        掲載中 {inProgressCount !== undefined && `(${inProgressCount})`}
      </Status>
      <Status onClick={() => setStatus('done')} active={status === 'done'}>
        売却済/掲載終了 {doneCount !== undefined && `(${doneCount})`}
      </Status>
    </Container>
  )
}
